import { render, staticRenderFns } from "./PendingOrderTable.vue?vue&type=template&id=0dfb7e0c"
import script from "./PendingOrderTable.vue?vue&type=script&lang=js"
export * from "./PendingOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports